import {
  RELIGION_LOADING,
  GET_RELIGION,
  GET_RELIGION_SUCCESS,
  GET_RELIGION_FAIL,
  ADD_RELIGION_SUCCESS,
  ADD_RELIGION_FAIL,
  DELETE_RELIGION_SUCCESS,
  DELETE_RELIGION_FAIL,
  UPDATE_RELIGION_SUCCESS,
  UPDATE_RELIGION_FAIL
} from "./actionType";

const INIT_STATE = {
  religions: [],
  error: {},
};

const Religion = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_RELIGION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_RELIGION:
          return {
            ...state,
            religions: action.payload.data,
            isReligionCreated: false,
            isReligionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_RELIGION_FAIL:
      switch (action.payload.actionType) {
        case GET_RELIGION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isReligionCreated: false,
            isReligionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_RELIGION: {
      return {
        ...state,
        isReligionCreated: false,
        loading: true,
      };
    }

    case RELIGION_LOADING: {
      return {
        ...state,
        isReligionCreated: false,
        loading: true,
      };
    }

    case ADD_RELIGION_SUCCESS:
      return {
        ...state,
        isReligionCreated: true,
        loading: false,
        religions: [...state.religions],
      };

    case ADD_RELIGION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_RELIGION_SUCCESS:
      return {
        ...state,
        loading: false,
        religions: state.religions.filter(
          religion => religion.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_RELIGION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_RELIGION_SUCCESS:
      return {
        ...state,
        loading: false,
        religions: state.religions.map(religion =>
          religion.id.toString() === action.payload.data.id.toString() ? { ...religion, ...action.payload.data } : religion
        ),
      };

    case UPDATE_RELIGION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export default Religion;